import styled from 'styled-components';

export const wrapper = styled.div`
    height: 100%;
    width: 100%;
`;